import { INotificationCenterStyles } from "@novu/notification-center";

const primaryColor = "#00875D";
const secondaryColor = "#FFFFFF";
const primaryTextColor = "#343434";
const secondaryTextColor = "#494F55";
const unreadBackGroundColor = "red";
const primaryButtonBackGroundColor = primaryColor;
const secondaryButtonBackGroundColor = secondaryColor;
const dropdownBorderStyle = "0px solid #AFE1AF";
const tabLabelAfterStyle = "#AFE1AF !important";
const ncWidth = "380px !important";
const fontFamily = "Montserrat, sans-serif";
const border = "2px solid red";
const linearGraident = `linear-gradient( 90deg, rgba(178, 223, 206, 0.5) 0%, rgba(237 237 237 / 50%) 100%)`;

const styles: INotificationCenterStyles = {
  bellButton: {
    root: {
      marginTop: "0px",
      svg: {
        color: "rgb(52, 52, 52)",
        minWidth: "20px",
        minHeight: "20px"
      }
    },
    dot: {
      rect: {
        fill: primaryColor,
        strokeWidth: "0",
        width: "8px",
        height: "8px",
        x: 8,
        y: 2
      }
    }
  },
  unseenBadge: {
    root: {
      color: secondaryColor,
      background: primaryColor,
      marginLeft: "10px"
    }
  },
  popover: {
    // root: { zIndex: -99 as any, },

    arrow: {
      // backgroundColor: primaryColor,
      // borderLeftColor: secondaryColor,
      // borderTopColor: secondaryColor,
    },
    dropdown: {
      border: dropdownBorderStyle,
      borderRadius: "8px",
      maxWidth: ncWidth
      // marginTop: "25px",
    }
  },
  header: {
    root: {
      backgroundColor: secondaryColor,
      // "&:hover": { backgroundColor: primaryColor },
      cursor: "pointer",
      color: primaryTextColor,
      fontFamily
    },
    cog: { opacity: 1 },
    markAsRead: {
      color: primaryTextColor,
      fontSize: "14px"
      // display:"flex",
      // justifyContent:"center",
    },
    title: { color: primaryTextColor },
    backButton: {
      color: primaryTextColor
    }
  },
  layout: {
    root: {
      background: secondaryColor,
      maxWidth: ncWidth,
      boxShadow: "0px 5px 15px  #787878"
    }
  },
  // TODO : change the loader
  loader: {
    root: {
      stroke: primaryTextColor
    }
  },
  accordion: {
    item: {
      backgroundColor: secondaryColor,
      ":hover": {
        backgroundColor: secondaryColor
      }
    },
    content: {
      backgroundColor: secondaryColor,
      borderBottomLeftRadius: "7px",
      borderBottomRightRadius: "7px"
    },
    control: {
      ":hover": {
        backgroundColor: secondaryColor
      },
      color: primaryTextColor,
      title: {
        color: primaryTextColor
      }
    },
    chevron: {
      color: primaryTextColor
    }
  },
  notifications: {
    root: {
      ".nc-notifications-list-item": {
        // backgroundColor: secondaryColor
        // background:linearGraident,
      }
    },
    listItem: {
      contentLayout: {
        fontFamily
      },
      layout: {
        borderRadius: "8px",
        color: primaryTextColor,
        "div:has(> .mantine-Avatar-root)": {
          border: "none",
          width: "20px",
          height: "20px",
          minWidth: "20px"
        },
        ".mantine-Avatar-root": {
          width: "20px",
          height: "20px",
          minWidth: "20px"
        },
        ".mantine-Avatar-image": {
          width: "20px",
          height: "20px",
          minWidth: "20px"
        }
      },
      timestamp: { color: secondaryTextColor, fontWeight: "normal" },
      dotsButton: {
        path: {
          fill: primaryTextColor
        }
      },
      unread: {
        "::before": { background: primaryColor },
        background: linearGraident
      },
      buttons: {
        primary: {
          background: primaryButtonBackGroundColor,
          color: secondaryColor,
          "&:hover": {
            background: "rgb(0 135 93 / 0.9)",
            color: secondaryColor
          }
        },
        secondary: {
          background: secondaryColor,
          color: primaryColor,
          border: "1.5px solid rgb(229, 231, 235)",
          "&:hover": {
            background: "rgb(0 135 93 / 0.05)"
          }
        }
      },
      title: {
        fontFamily,
        color: secondaryTextColor
      },
      read: {
        // background: "gray"
      }
    }
  },
  actionsMenu: {
    item: {
      "&:hover": { backgroundColor: primaryColor, color: "white", fontFamily }
    },
    dropdown: {
      backgroundColor: secondaryColor,
      color: secondaryColor,
      fontFamily
    }
    // arrow: {
    //     backgroundColor: primaryColor,
    //     borderTop: "0",
    //     borderLeft: "0"
    // }
  },
  preferences: {
    item: {
      title: { color: primaryTextColor },
      divider: { borderTopColor: primaryColor },
      channels: { color: secondaryTextColor },
      content: {
        icon: { color: primaryTextColor },
        channelLabel: { color: primaryTextColor },
        success: { color: primaryTextColor }
      }
    },
    root: {
      fontFamily
    }
  },
  tabs: {
    tabLabel: {
      "::after": { border: "1px solid #00875D" },
      ":hover": { color: tabLabelAfterStyle },
      "[data-active]": { color: primaryColor },
      ">div": {
        color: primaryTextColor,
        fontSize: "12px",
        minHeight: "fit-content",
        fontWeight: "200px",
        lineHeight: "",
        margin: "0px",
        padding: "4px"
        // border
      }
    },
    tab: { color: primaryTextColor, fontWeight: "100px" },
    tabsList: {
      borderBottomColor: primaryColor,
      width: "100%",
      flexWrap: "nowrap",
      gap: "12px",
      overflowX: "scroll",
      "::-webkit-scrollbar": {
        width: "0px",
        display: "none"
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "transparent",
        border: "none"
      }
    }
  },
  switch: {
    // root: {},
    input: {
      color: primaryColor,
      background: primaryColor
    },
    thumb: {
      color: primaryColor
    },
    track: {
      color: secondaryColor
    }
  },
  footer: {
    root: { fontFamily }
  }
};

export default styles;
